interface CardImageProps
  extends React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {}

export default function CardImage({
  children,
  className = '',
  ...rest
}: CardImageProps) {
  return (
    <img className={`card-image ${className}`} {...rest}>
      {children}
    </img>
  );
}
